import React from 'react';
import SurveyListLoader from './parts/SurveyDraftListLoader';
import SurveyTable from './parts/SurveyDraftTable';

function SurveyDraftList() {
  return (
    <SurveyListLoader>
      <SurveyTable />
    </SurveyListLoader>
  );
}

export default SurveyDraftList;
